import React, {useState} from 'react';
import { connect } from 'react-redux';
import { Button } from '@progress/kendo-react-buttons';

import { searchPublications } from '../publication.actions';
import { useAuth0, getSelectedTenantId } from '../../app/auth';

//TODO: merge with common/searchBar component

const PublicationSearchComponent = (props) => {

    const [text, setText] = useState('');
    const [timeoutId, setTimeoutId] = useState(null);
    const { getTokenSilently, user } = useAuth0();

    const startSearch = async() => {
        clearTimeout(timeoutId);
        const token = await getTokenSilently();
        props.onSearch(text, token, getSelectedTenantId(user, token));
    };

    const handleTextChange = (event) => {
        clearTimeout(timeoutId);
        const newTimeoutId = setTimeout(() => {
            startSearch();
        }, 2000);

        setTimeoutId(newTimeoutId);
        setText(event.target.value);
    };

    const handleButtonClick = (event) => {
        event.preventDefault();
        startSearch();
    };

    const handleKeyPress = (event) => {
        if(event.which === 13 || event.keyCode === 13) {
            startSearch();
        }
    };

    return (
        <div className="search-box-container">
            <div className="search-box-internal-container">
                <input type="text" className="search-box"
                        placeholder="Search channel, Video URL"
                        value={text} onChange={handleTextChange} onKeyPress={handleKeyPress} />
                <Button primary icon="search" onClick={handleButtonClick} className="search-button" />
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => {
    const props = {
        onSearch: (text, token, tenantId) => {
            dispatch(searchPublications(text, token, tenantId));
        }
    };
    return props;
};
  
const PublicationSearch = connect(null, mapDispatchToProps)(PublicationSearchComponent);
export default PublicationSearch;